import type * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { GridItem } from '@xing-com/grid';
import { SingleSizeIllustrationHeroCompass } from '@xing-com/illustrations';
import { BodyCopy } from '@xing-com/typography';

import LoggedOutImage from './images/logged-out-career-hub-header.webp';
import { Styled } from './main-page-header.styles';

export const MainPageHeader: React.FC = () => {
  const { isLoggedOut } = useLoginState();
  const { formatMessage } = useIntl();

  return (
    <Styled.GridContainer variant="FullSize">
      <GridItem
        span={12}
        spanMedium={isLoggedOut ? 7 : 8}
        spanLarge={isLoggedOut ? 5 : 7}
      >
        <Styled.Header>
          <Styled.Hero size="medium">
            <FormattedMessage id="CAREER_HUB_HOME_HEADER_HEADLINE" />
          </Styled.Hero>
          <BodyCopy size="large" noMargin>
            <FormattedMessage id="CAREER_HUB_HOME_HEADER_SUBLINE" />
          </BodyCopy>
        </Styled.Header>
      </GridItem>
      {isLoggedOut ? (
        <GridItem {...{ span: 12, spanMedium: 5, startLarge: 7, spanLarge: 6 }}>
          <Styled.LoggedOutImage
            src={LoggedOutImage}
            alt={formatMessage({ id: 'CAREER_HUB_HOME_HEADER_ALT' })}
          />
        </GridItem>
      ) : (
        <GridItem {...{ span: 8, start: 3, spanMedium: 4, startMedium: 9 }}>
          <SingleSizeIllustrationHeroCompass />
        </GridItem>
      )}
    </Styled.GridContainer>
  );
};
